<template>
  <div>
    <el-row :gutter="20">
      <!-- 左栏：原始内容 -->
      <el-col :span="15">
        <el-card class="box-card">
          
          <el-row :gutter="0">
            <el-form :inline="true" class="demo-form-inline">
              <el-form-item label="系列">
                <el-select
                  v-model="price.cate1_id"
                  placeholder="系列"
                  @change="getCate2List"
                >
                  <el-option
                    v-for="item in cate1List"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="品名">
                <el-select v-model="price.cate2_id" placeholder="品名" @change="getAllStatistics">
                  <el-option
                    v-for="item in cate2List"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="分值">
                <el-select v-model="price.score" placeholder="请选择分值" @change="getTableData">
                  <el-option 
                    v-for="score in scores" 
                    :key="score"
                    :label="score.includes('sp') ? score : score + '分'"
                    :value="score"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item>
                <el-button type="primary" @click="getTableData">查询</el-button>
              </el-form-item> -->
              <el-form-item>
                <el-button type="success" @click="dialogVisible = true"
                  >新增</el-button
                >
              </el-form-item>
            </el-form>
          </el-row>
          <el-table v-loading="tableLoading" element-loading-text="查询数据中..." :data="tableData" style="width: 100%">
            <el-table-column prop="id" label="编号"></el-table-column>
            <el-table-column prop="avp" label="参考价"></el-table-column>
            <el-table-column prop="max" label="最高价"></el-table-column>
            <el-table-column prop="min" label="最低价"></el-table-column>
            <el-table-column prop="date_start" label="开始日期"></el-table-column>
            <el-table-column prop="date_end" label="结束日期"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="danger" @click="del(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-dialog title="新增" :visible.sync="dialogVisible">
            <el-form :model="price" :rules="rules" ref="priceRef">
              <div
                v-show="chartFlag"
                id="chart1"
                :style="{ width: '400px', height: '350px' }"
              ></div>
              <el-form-item label="参考价" label-width="120px" prop="avp">
                <el-input v-model="price.avp" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="最高价" label-width="120px" prop="max">
                <el-input v-model="price.max" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="最低价" label-width="120px" prop="min">
                <el-input v-model="price.min" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="时间范围" label-width="120px">
                <el-date-picker
                  v-model="price.dateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="success" @click="compute">一键计算</el-button>
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="add">提 交</el-button>
            </div>
          </el-dialog>
        </el-card>
      </el-col>
      
      <!-- 右栏：统计功能 -->
      <el-col :span="9">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>{{ getCate1Name() }} - {{ getCate2Name() }} 各分值记录数统计</span>
          </div>
          
          <!-- 统计区域分为左右两部分 -->
          <div class="statistics-wrapper">
            <!-- 左半边：price已有score对应的数量 -->
            <div class="statistics-section left-section">
              <div class="section-title">价格统计 ({{ !priceScoresLoading && priceScoresData ? priceScoresData.length : '0' }})</div>
              
              <!-- 加载中状态 -->
              <div v-if="priceScoresLoading" class="loading-container">
                <i class="el-icon-loading"></i>
                <span>正在统计中...</span>
              </div>
              
              <!-- 未选择或无数据状态 -->
              <div v-if="!priceScoresLoading && priceScoresData.length === 0" class="empty-container">
                <el-empty description="暂无price分值数据" />
              </div>
              
              <!-- 统计信息展示 -->
              <div v-if="!priceScoresLoading && priceScoresData.length > 0" class="statistics-container">
                <div class="statistics-item" v-for="item in priceScoresData" :key="item.score">
                  <div class="statistics-label">{{ item.score.includes('sp') ? item.score : item.score + '分' }}</div>
                  <div class="statistics-value">{{ item.cnt }}条记录</div>
                </div>
              </div>
            </div>
            
            <!-- 右半边：记录对应的数量 -->
            <div class="statistics-section right-section">
              <div class="section-title">交易记录数量统计 ({{ !statisticsLoading && statisticsData ? statisticsData.length : '0' }})</div>
              
              <!-- 加载中状态 -->
              <div v-if="statisticsLoading" class="loading-container">
                <i class="el-icon-loading"></i>
                <span>正在统计中...</span>
              </div>
              
              <!-- 未选择或无数据状态 -->
              <div v-if="!statisticsLoading && statisticsData.length === 0" class="empty-container">
                <el-empty description="暂无记录数量数据" />
              </div>
              
              <!-- 统计信息展示 -->
              <div v-if="!statisticsLoading && statisticsData.length > 0" class="statistics-container">
                <div 
                  class="statistics-item" 
                  :class="{ 'unsynced-item': !isScoreInPriceScores(item.score) }" 
                  v-for="item in statisticsData" 
                  :key="item.score"
                  :title="!isScoreInPriceScores(item.score) ? '该记录未同步到左侧价格中' : ''"
                >
                  <div class="statistics-label">{{ item.score.includes('sp') ? item.score : item.score + '分' }}</div>
                  <div v-if="!isScoreInPriceScores(item.score)" class="unsynced-tag">未设置价格</div>
                  <div class="statistics-value">{{ item.cnt }}条记录</div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from "@/utils/request";
import { getAllScores } from "@/utils/getAllScores";
export default {
  name: "AdminPrice",
  data() {
    return {
      cate1List: [],
      cate2List: [],
      scores: [],
      priceArr: [],
      cate1: "",
      cate2: "",
      pagenum: 1,
      pagesize: 2,
      total: 0,
      tableData: [],
      dialogVisible: false,
      addCate2Visable: false,
      price: {},
      chartFlag: false,
      chartlist: [],
      // 统计功能相关数据
      statisticsData: [],
      statisticsLoading: false,
      // price score统计数据
      priceScoresData: [],
      priceScoresLoading: false,
      // 表格加载状态
      tableLoading: false,
      rules: {
        name: [
          { required: true, message: "请输入系列", trigger: "blur" },
          { min: 1, max: 20, message: "长度在2到20之间", trigger: "blur" },
        ],
        avp: [{ required: true, message: "请选择正确的系列", trigger: "blur" }],
        max: [{ required: true, message: "请选择正确的品名", trigger: "blur" }],
        min: [{ required: true, message: "请选择正确的分值", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getCate1List();
    this.scores = getAllScores();
  },
  methods: {
    getCate1List() {
      //发起Cate1请求
      console.log("发起请求");
      request.get("/common/getCate1List", {}).then((res) => {
        this.cate1List = res.data;
      });
    },
    getCate2List() {
      request
        .get("/common/getCate2List", {
          params: {
            id: this.price.cate1_id,
          },
        })
        .then((res) => {
          this.cate2List = res.data;
          // 如果已选择品名，自动获取统计数据
          if (this.price.cate2_id) {
            this.getPriceScoresStatistics();
            this.getStatistics();
          }
        });
    },
    getTableData() {
      this.tableLoading = true;
      request
        .get("/admin/price", {
          params: {
            cate2_id: this.price.cate2_id,
            score: this.price.score,
          },
        })
        .then((res) => {
          this.tableData = res.data;
        })
        .catch((error) => {
          console.error("获取表格数据失败:", error);
          this.tableData = [];
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // 同时获取所有统计数据
    getAllStatistics() {
      this.getPriceScoresStatistics();
      this.getStatistics();
    },
    
    // 获取price已有score对应的数量统计数据
    getPriceScoresStatistics() {
      if (!this.price.cate2_id) {
        this.priceScoresData = [];
        return;
      }
      
      this.priceScoresLoading = true;
      request
        .get("/admin/price/getPriceCate2Scores", {
          params: {
            cate2_id: this.price.cate2_id,
          },
        })
        .then((res) => {
          this.priceScoresData = res.data || [];
        })
        .catch((error) => {
          console.error("获取price分值统计数据失败:", error);
          this.priceScoresData = [];
        })
        .finally(() => {
          this.priceScoresLoading = false;
        });
    },
    
    // 获取分值统计数据（记录对应的数量）
    getStatistics() {
      if (!this.price.cate2_id) {
        this.statisticsData = [];
        return;
      }
      
      this.statisticsLoading = true;
      request
        .get("/admin/price/getRecordCate2Scores", {
          params: {
            cate2_id: this.price.cate2_id,
          },
        })
        .then((res) => {
          this.statisticsData = res.data || [];
        })
        .catch((error) => {
          console.error("获取统计数据失败:", error);
          this.statisticsData = [];
        })
        .finally(() => {
          this.statisticsLoading = false;
        });
    },
    resetForm() {
      //重置
      console.log("开始重置");
      this.price.avp = "";
      this.price.max = "";
      this.price.min = "";
      this.price.date_start = "";
      this.price.date_end = "";
      this.price.dateRange = [];
    },
    add() {
      this.$refs.priceRef.validate((valid) => {
        console.log(valid);
        if (!valid) return;
        //发起网络请求
        this.price.date_start = this.price.dateRange[0];
        this.price.date_end = this.price.dateRange[1];
        request.post("/admin/price", this.price).then((res) => {
          if (res.code == "0") {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.getTableData();
            this.resetForm();
            this.dialogVisible = false;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
      });
    },
    initChart(name) {
      var myChart = this.$echarts.init(document.getElementById(name));
      // 指定图表的配置项和数据
      var option = {
        title: {
          text: "分布图",
        },
        xAxis: {
          name: "价格",
        },
        yAxis: {
          name: "序号",
        },
        series: [
          {
            symbolSize: 10,
            type: "scatter",
            data: this.chartlist,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    compute() {
      request
        .get("/admin/price/compute", {
          params: {
            cate2_id: this.price.cate2_id,
            score: this.price.score,
            date_start: this.price.dateRange[0],
            date_end: this.price.dateRange[1],
          },
        })
        .then((res) => {
          if (res.code == "0") {
            console.log(res.data);
            let dic = res.data;
            dic.cate1_id = this.price.cate1_id;
            dic.cate2_id = this.price.cate2_id;
            dic.score = this.price.score;
            dic.dateRange = this.price.dateRange;
            this.price = JSON.parse(JSON.stringify(dic));
            this.chartlist = dic.list;

            this.chartFlag = true;
            this.initChart("chart1");
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
    },
    // 获取当前选择的系列名称
    getCate1Name() {
      if (!this.price.cate1_id) return '';
      const cate1 = this.cate1List.find(item => item.id === this.price.cate1_id);
      return cate1 ? cate1.name : '';
    },
    
    // 获取当前选择的品名名称
    getCate2Name() {
      if (!this.price.cate2_id) return '';
      const cate2 = this.cate2List.find(item => item.id === this.price.cate2_id);
      return cate2 ? cate2.name : '';
    },
    
    // 检查右侧的分值是否存在于左侧的priceScoresData中
    isScoreInPriceScores(score) {
      if (!this.priceScoresData || this.priceScoresData.length === 0) {
        return false;
      }
      return this.priceScoresData.some(item => item.score === score);
    },
    
    del(id) {
      console.log(id);
      this.$confirm("是否删除该系列？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          request.delete("/admin/price/" + id, {}).then((res) => {
            if (res.code == "0") {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.getTableData();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          console.log("取消");
        });
    },
  },
};
</script>

<style scoped>
/* 统计功能样式 */
.statistics-container {
  margin-top: 10px;
  max-height: 500px;
  overflow-y: auto;
}

.statistics-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  margin-bottom: 8px;
  background-color: #f5f7fa;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.statistics-label {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  flex: 1;
}

.statistics-value {
  font-size: 14px;
  color: #606266;
  font-weight: 600;
  margin-right: 12px;
}

.statistics-item:hover {
  background-color: #e4e7ed;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.statistics-wrapper {
  display: flex;
  gap: 16px;
  height: 100%;
}

.statistics-section {
  flex: 1;
  padding: 12px;
  background-color: #fafafa;
  border-radius: 8px;
  height: 400px;
  display: flex;
  flex-direction: column;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid #409eff;
}

.statistics-container {
  flex: 1;
  margin-top: 10px;
  overflow-y: auto;
  padding-right: 4px;
}



/* 未同步记录样式 */
.unsynced-item {
  background-color: #fffbe6;
  border-left: 4px solid #f7ba2a;
}

.unsynced-item:hover {
  background-color: #fff1c2;
}

.unsynced-tag {
  font-size: 13px;
  color: #ec8e1c;
  background-color: #fff7e6;
  padding: 2px 6px;
  border-radius: 3px;
  margin-left: 8px;
}

/* 加载中样式 */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  color: #606266;
}

.loading-container i {
  font-size: 24px;
  margin-bottom: 10px;
  color: #409eff;
  animation: el-rotate 1s linear infinite;
}

/* 空状态样式 */
.empty-container {
  padding: 40px 0;
}

/* 左栏表格样式 */
.el-table {
  margin-top: 20px;
}

/* 卡片样式 */
.box-card {
  margin-bottom: 20px;
  height: 100%;
}

/* 整体布局 */
.el-row {
  margin-bottom: 20px;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .statistics-container {
    max-height: 400px;
  }
}

@media (max-width: 992px) {
  .el-col {
    margin-bottom: 20px;
  }
}
</style>
